import { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

import { Flex } from '@revenuemarket/cds';
import { ICellEditorComp } from 'ag-grid-community';
import { CustomCellEditorProps } from 'ag-grid-react';

import { LabeledBankAccountTransaction } from '~apis/cash-flow-overview/transactions/getTransactions';
import SelectBusinessEntity from '~components/Transactions/MappingModal/SelectBusinessEntity';

interface Props extends CustomCellEditorProps<LabeledBankAccountTransaction, number> {}

const AGGridBusinessEntityEditor = (
  { data, value, api, column, node, onValueChange }: Props,
  ref: ForwardedRef<ICellEditorComp>,
) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(true);
  const [innerValue, setInnerValue] = useState(value ?? undefined);

  useImperativeHandle(
    ref,
    () => ({
      getGui: () => containerRef.current ?? document.body,
      getValue: () => innerValue,
    }),
    [innerValue],
  );

  useEffect(() => {
    if (!open) {
      api.stopEditing(false);
      api.setFocusedCell(node.rowIndex as number, column);
    }
  }, [api, column, node.rowIndex, open]);

  return (
    <Flex ref={containerRef} align="center" style={{ height: '100%' }}>
      <SelectBusinessEntity
        value={innerValue}
        onChange={(value, label) => {
          data.businessEntityLabel = label;
          setInnerValue(value);
          onValueChange?.(value);
          setTimeout(() => {
            api.clearFocusedCell();
          }, 500);
        }}
        selectProps={{
          open,
          onDropdownVisibleChange: setOpen,
          autoFocus: true,
          bordered: false,
          style: { width: '100%' },
        }}
      />
    </Flex>
  );
};

export default forwardRef(AGGridBusinessEntityEditor);
